import React, { useEffect, useRef } from 'react';

interface AutoSubmitFormProps {
  action: string; // URL to post to
  data: Record<string, string | number | boolean>; // Form data
  method?: 'POST' | 'GET'; // Default is POST
}

export const AutoSubmitForm: React.FC<AutoSubmitFormProps> = ({ action, data, method = 'POST' }) => {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  }, []);

  return (
    <form ref={formRef} action={action} method={method} style={{ display: 'none' }}>
      {Object.entries(data).map(([key, value]) => (
        <input key={key} type="hidden" name={key} value={String(value)} />
      ))}
      <noscript>
        <button type="submit">Click to continue</button>
      </noscript>
    </form>
  );
};
